import { Button } from '@/components/ui/button';

const APP_URL = 'https://app.lindberghai.com';

export const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="max-w-[1200px] mx-auto px-4 h-[72px] flex items-center justify-between">
        <div className="flex items-center">
          <a href="/" className="flex items-center gap-2">
            <img
              src="/logo-icon.png"
              alt="LindberghAI icon"
              className="h-7 w-auto"
            />
            <span className="text-xl font-semibold tracking-tight text-foreground">
              Lindbergh<span className="text-primary">AI</span>
            </span>
          </a>
        </div>

        <div className="flex items-center space-x-3">
          <Button
            onClick={() => window.open(APP_URL, '_blank')}
            className="bg-white hover:bg-gray-50 text-[#18181B] border border-gray-200 rounded-lg px-4 py-2 text-[15px] font-medium"
          >
            Log In
          </Button>
          <Button
            onClick={() => window.open(APP_URL, '_blank')}
            className="bg-[#27272A] hover:bg-[#3F3F46] text-white rounded-lg px-4 py-2 text-[15px] font-medium transition-colors"
          >
            Try for Free
          </Button>
        </div>
      </div>
    </header>
  );
};
